export default "__VITE_ASSET__BYbtdhS3__"